import Cookies from 'js-cookie'

const ID_BIZ_AUTH_INFO_COOKIE_NAME = 'OSTAY_GUEST_ID_BIZ_AUTH_INFO'

const LANG_KEY = 'OSTAY_LANG_KEY'
const OSTAY_IDENTIFICATION_AUTH = 'OSTAY_IDENTIFICATION_AUTH'

export default class CookieManager {
  static getGuestIDCheckedInfo () {
    var guestIDCheckedInfo = Cookies.get(ID_BIZ_AUTH_INFO_COOKIE_NAME)
    return guestIDCheckedInfo ? JSON.parse(decodeURIComponent(guestIDCheckedInfo)) : null
  }

  static setCustomerInfo (obj) {
    Cookies.set(OSTAY_IDENTIFICATION_AUTH, obj)
  }

  static getCustomerInfo () {
    return Cookies.getJSON(OSTAY_IDENTIFICATION_AUTH)
  }

  // 当前语言环境
  static setLang (lang) {
    Cookies.set(LANG_KEY, lang)
  }

  static getLang () {
    return Cookies.get(LANG_KEY)
  }
}
